'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_GoogleSyncResponse(messages) {
  this.Lq = null;
  this.Lq = messages;
}
export { $c_Lmealorama_GoogleSyncResponse as $c_Lmealorama_GoogleSyncResponse };
$p = $c_Lmealorama_GoogleSyncResponse.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_GoogleSyncResponse;
/** @constructor */
function $h_Lmealorama_GoogleSyncResponse() {
}
export { $h_Lmealorama_GoogleSyncResponse as $h_Lmealorama_GoogleSyncResponse };
$h_Lmealorama_GoogleSyncResponse.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-2021778986), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_GoogleSyncResponse)) {
    var x = this.Lq;
    var x$2 = x$0.Lq;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 1;
});
$p.r = (function() {
  return "GoogleSyncResponse";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.Lq;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_GoogleSyncResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jv)));
}
export { $isArrayOf_Lmealorama_GoogleSyncResponse as $isArrayOf_Lmealorama_GoogleSyncResponse };
var $d_Lmealorama_GoogleSyncResponse = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_GoogleSyncResponse, "mealorama.GoogleSyncResponse", ({
  jv: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_GoogleSyncResponse as $d_Lmealorama_GoogleSyncResponse };
//# sourceMappingURL=mealorama.-Google-Sync-Response.js.map
